import React from 'react'
import { ButtonGroup } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import { ShowIf } from '@ztechapps/webui.util'

/** Props for a chip of the pivot filter bar. */
export type PivotFilterChipProps = {
  label: string
  /** What the filter keeps, shown after the label. */
  text?: string
  /** Whether the chip holds a filter, which its clear action removes. */
  isActive: boolean
  onOpen: () => void
  onClear: () => void
}

/**
 * A filter chip opening the filter dialog, with a clear action beside it while the filter is set. A long label is cut
 * with an ellipsis at the chip's own row width, so the clear action stays on screen.
 */
export const PivotFilterChip = ({ label, text, isActive, onOpen, onClear }: PivotFilterChipProps) => (
  <ButtonGroup size="sm" className="mw-100">
    <BusyButton
      variant="outline-secondary"
      bsSize="sm"
      icon="filter"
      text={label}
      active={isActive}
      onClick={onOpen}
      className="text-truncate"
      style={{ minWidth: 0 }}
    >
      <ShowIf condition={!!text}>
        <span className="fw-semibold">{text}</span>
      </ShowIf>
    </BusyButton>
    <ShowIf condition={isActive}>
      <BusyButton
        variant="outline-secondary"
        bsSize="sm"
        icon="times"
        className="flex-shrink-0"
        title={`Clear ${label} filter`}
        aria-label={`Clear ${label} filter`}
        onClick={onClear}
      />
    </ShowIf>
  </ButtonGroup>
)
